




import {mixins} from "vue-class-component";
import {Component, Prop} from "vue-property-decorator";
import {PickingListCostStatus} from "@/enums/status";
import {IdMapper} from "@/interfaces/state/base";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
  name: 'PLCostStatusLabel'
})
export default class extends mixins(CommonMixin) {
  @Prop({ required: true, type: Number }) readonly status!: number;
  PickingListCostStatus = PickingListCostStatus;
  colorMap: IdMapper<string> = {
    [PickingListCostStatus.NotYetPay]: 'warning',
    [PickingListCostStatus.Payed]: 'success',
    [PickingListCostStatus.Reject]: 'error',
  }
}
